// API Configuration
export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    TIMEOUT: parseInt(process.env.REACT_APP_REQUEST_TIMEOUT) || 10000,
    RETRY_ATTEMPTS: 3,
};

// Email Configuration
export const EMAIL_CONFIG = {
    SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_fbui7tr',
    TEMPLATE_ID: {
        CONTACT: process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE || 'contact_template',
        ORDER: process.env.REACT_APP_EMAILJS_ORDER_TEMPLATE || 'order_template',
    },
    PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'XVQAh9z8OME29ELQo',
};

// UI Configuration
export const UI_CONFIG = {
    SCROLL_THRESHOLD: 90,
    NOTIFICATION_TIMEOUT: 5000,
    LOADING_TIMEOUT: 1500,
    ANIMATION_DURATION: 300,
};

// Form Validation
export const VALIDATION_RULES = {
    NAME_MIN_LENGTH: 2,
    NAME_MAX_LENGTH: 50,
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE_REGEX: /^[+]?[1-9][\d]{0,15}$/,
    MESSAGE_MIN_LENGTH: 10,
    MESSAGE_MAX_LENGTH: 1000,
};

// Navigation
export const ROUTES = {
    HOME: '/',
    BIOGRAPHY: '/biografia',
    BLOG: '/blog',
    BOOKS: '/libros',
    PAINTINGS: '/pinturas',
    CONTACT: '/contacto',
    COOKIES_POLICY: '/politica-de-cookies',
    PRIVACY_POLICY: '/politica-de-privacidad',
    LEGAL_WARNING: '/aviso-legal',
};

// Social Media
export const SOCIAL_MEDIA = {
    TWITTER: 'https://twitter.com/SilviaProst',
    LINKEDIN: 'https://www.linkedin.com/in/fabricioalmaraz/',
    GITHUB: 'https://github.com/Fabri31295',
};

// Analytics
export const ANALYTICS = {
    TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID || 'UA-148787297-1',
    ENABLED: process.env.REACT_APP_ENABLE_ANALYTICS === 'true' && process.env.NODE_ENV === 'production',
};

// Error Messages - These will be handled by translations
export const ERROR_MESSAGES = {
    NETWORK_ERROR: 'errors.networkError',
    VALIDATION_ERROR: 'errors.validationError',
    UNEXPECTED_ERROR: 'errors.unexpectedError',
    EMAIL_ERROR: 'errors.emailError',
    FORM_ERROR: 'errors.formError',
};

// Success Messages - These will be handled by translations
export const SUCCESS_MESSAGES = {
    EMAIL_SENT: 'success.emailSent',
    ORDER_SENT: 'success.orderSent',
    FORM_SUBMITTED: 'success.formSubmitted',
}; 